import {Component, OnInit} from '@angular/core';
import {Constants} from '../../../_constants/constants';
import {ColumnFormats} from '../../../_constants/column-formats';
import {BaseWidgetComponent} from '../base-widget.component';
import {TabReportResult} from '../../../_models/report/tab-report-result';
import {TabReportService} from '../../../_services/tab-report.service';
import {multiplyCurrency} from '../../../_utils/currency-math';
import {Sort} from '../../../_models/report/sort';
import {ColumnFormatterService} from '../../../_services/column-formatter.service';

@Component({
    selector: 'bb-pie-chart-widget',
    templateUrl: './pie-chart-widget.component.html',
    styleUrls: ['./pie-chart-widget.component.scss'],
})
export class PieChartWidgetComponent extends BaseWidgetComponent implements OnInit {
    data: any;

    constructor(
        private tabReportService: TabReportService,
        columnFormatterService: ColumnFormatterService
    ) {
        super(columnFormatterService);
    }

    ngOnInit() {
    }

    refresh() {
        this.loading = true;
        this.dataLoading.emit();

        const sort = new Sort({
            column: this.tabReport.columns[1],
            sortDirection: 'DESC'
        });

        this.tabReportService.runShell(this.getFilteredReport(), 0, 100, this.startDate, this.endDate, sort, true)
            .subscribe((trr: TabReportResult) => {
                if (!!trr && !!trr.data && trr.data.length > 0) {
                    const chart = {
                        labels: [],
                        datasets: [
                            {
                                ...Constants.CHART_CONFIG,
                                data: []
                            }
                        ]
                    };
                    const labelColumn = trr.columns[0];
                    const valueColumn = trr.columns[1];
                    let valid = false;
                    for (const row of trr.data) {
                        const value = row.data[valueColumn.accessKey];
                        if (!!value) {
                            valid = true;
                            chart.labels.push(this.getRowValue(row, labelColumn));

                            if (valueColumn.format === ColumnFormats.PERCENT) {
                                chart.datasets[0].data.push(multiplyCurrency(value, 100));
                            } else {
                                chart.datasets[0].data.push(Number(value));
                            }
                        }
                    }
                    this.data = valid ? chart : null;
                } else {
                    this.data = null;
                }

                this.loading = false;
                this.error = false;
                this.dataReady.emit();
            }, () => {
                this.loading = false;
                this.error = true;
            });
    }
}
